import { createContext } from 'react';

const ColorModeContext = createContext({
	// mode: 'light', // usaba en settings.jsx
	toggleColorMode: () => {},
});

export default ColorModeContext;
